export default __webpack_public_path__ + "f7a32f981452b8628f23200735f6e1d3.png";